import React, { PureComponent } from 'react';
import { VirtualPack } from '~/Api/Analytics/VirtualBrand';
import { AnalyticDataSources } from '~/Api/Analytics/VirtualBrand/mapAnalyticVirtualBrand';

import styles from '../RegistrationTab/styles.less';
import LoadableERPChartContainer from './LoadableERPChartContainer';

export type Props = {
	virtualBrandName: string;
	virtualBrandId: string;
	virtualBrandAvailability: { [countryCode: string]: AnalyticDataSources };
	virtualPackAvailability: { [virtualPackId: string]: { [countryCode: string]: AnalyticDataSources } };
	virtualPack: VirtualPack | null;
	currency: string | null;
};

export default class ERPTab extends PureComponent<Props> {
	render() {
		const { virtualBrandId, virtualBrandName, virtualPack } = this.props;

		if (!virtualPack) {
			return <h2 className={styles.heading}>Choose a package to show an IRP model.</h2>;
		}

		return (
			<LoadableERPChartContainer
				brandId={virtualBrandId}
				packDistinctName={virtualPack.distinctName}
				packId={virtualPack.id}
				virtualBrandName={virtualBrandName}
			/>
		);
	}
}
